const uploadModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/packageManagement/file-management/upload/upload-modal/upload-modal.html',
  controller: 'UploadModalController',
};

angular
    .module('package-management.module')
    .component('uploadModal', uploadModal);
